import { type GetHookResponse } from '../hooks'
import { videoKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type VideoWithUserData, type VideoId, HOUR, type VideoGetInput, type VideoGetSuccess } from '@terros/common'

const VIDEO_MISSING: VideoId = `Video_MISSING`

export function useVideo(videoId: VideoId = VIDEO_MISSING): GetHookResponse<VideoWithUserData> {
  return useTantalimQuery<VideoGetInput, VideoGetSuccess, VideoWithUserData>({
    convertResponse: (data) => data,
    input: { videoId },
    queryKey: videoKey(videoId),
    url: '/video/get',
    options: {
      staleTime: HOUR,
      gcTime: 4 * HOUR,
      enabled: videoId !== VIDEO_MISSING,
    },
  })
}
